import { AdaLocalizedDatePipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TableColumnDirective, TableComponentModule } from '@adaptiva/widgets/table';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { MetadataHistoryObjectTableComponent } from './metadata-history-object-table.component';

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	ContainerComponentModule,
	MenuComponentModule,
	OverlayComponentModule,
	TableComponentModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		AdaLocalizedDatePipe,
		CommonModule,
		TableColumnDirective,
		TemplateMarkerDirectiveModule,
		WIDGETS,
	],
	declarations: [MetadataHistoryObjectTableComponent],
	exports: [MetadataHistoryObjectTableComponent]
})
export class MetadataHistoryObjectTableComponentModule {

}
